<template>
  <div class="relative flex w-13 flex-col items-center gap-2">
    <div class="group relative">
      <input
        :aria-label="
          $t('filter_color_chip.select_color', { color: color.name })
        "
        :data-color-id="color.id"
        :value="color"
        class="absolute z-20 size-full cursor-pointer appearance-none rounded-lg"
        data-testid="filter-color-chip"
        type="checkbox"
      />
      <div class="relative flex size-10 items-center justify-center">
        <span
          v-if="hasMixedColors"
          class="absolute grid size-full grid-cols-2 overflow-hidden rounded-lg lg:group-hover:border lg:group-hover:border-black lg:group-hover:outline lg:group-hover:outline-2 lg:group-hover:outline-offset-[-3px] lg:group-hover:outline-white"
        >
          <span
            v-for="(hex, index) in colorCode"
            :key="`${index}-${hex}`"
            :class="{
              'last-of-type:col-span-full': isNumberOfMixColorsOdd,
              'border border-gray-400': isBrightColor,
            }"
            :style="{ backgroundColor: hex }"
            class="size-full"
          />
        </span>
        <span
          v-else
          :class="{ 'border border-gray-400': isBrightColor }"
          :style="{ backgroundColor: `${colorCode}` }"
          class="absolute size-full rounded-lg lg:group-hover:border lg:group-hover:border-black lg:group-hover:outline lg:group-hover:outline-2 lg:group-hover:outline-offset-[-3px] lg:group-hover:outline-white"
        />

        <IconCheck
          :class="{
            '!text-anthracite-800': isBrightColor,
            'opacity-100': isChecked,
          }"
          class="z-10 size-5 text-white opacity-0 lg:group-hover:opacity-100"
        />
      </div>
    </div>

    <div
      class="max-w-full truncate text-center text-sm font-medium text-gray-500"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import Color from 'color'
import type { AttributesFilterValue } from '@scayle/storefront-nuxt'
import { ProductColor } from '~/constants/product'

const { isChecked = false, color } = defineProps<{
  color: AttributesFilterValue
  isChecked?: boolean
}>()

const colorCode = computed(() => ProductColor[color.name])

const isBrightColor = computed(() => Color(colorCode.value).luminosity() > 0.7)

const hasMixedColors = computed(() => Array.isArray(colorCode.value))

const isNumberOfMixColorsOdd = computed<boolean>(() => {
  if (!hasMixedColors.value || !colorCode.value) {
    return false
  }
  return colorCode.value.length % 2 !== 0
})
</script>
